import { useState } from 'react';
import MLIcon from '../../../../MLIcon/MLIcon';
import MLButton from '../../../../MLButton/MLButton';
import s from './Accordion.module.css';
import classNames from 'classnames';

const SimpleAccordion = ({
  children,
  title,
  onToggle,
  isOpen: controlledIsOpen,
  isMobile,
  renderContent,
}) => {
  const [simpleIsOpen, setSimpleIsOpen] = useState(true);
  const isOpen =
    controlledIsOpen !== undefined ? controlledIsOpen : simpleIsOpen;

  const handleToggle = () => {
    if (controlledIsOpen === undefined) {
      setSimpleIsOpen(!simpleIsOpen);
    }
    if (onToggle) {
      onToggle(!isOpen);
    }
  };

  // Render primaryMetrics as a function to pass isAccordionOpen prop
  const renderPrimaryMetrics = () => {
    if (typeof renderContent === 'function') {
      return renderContent({ isAccordionOpen: isOpen });
    }
    return renderContent;
  };

  return (
    <div
      className={classNames(s.accordion, {
        [s.openPadding]: isOpen && !isMobile,
        [s.closedPadding]: !isOpen,
      })}
      data-test-id={`individual_student_gb_performance_overview_${isOpen ? 'expanded' : 'collapsed'}`}
    >
      <div
        className={s.accordionButton}
        data-test-id="individual_student_gb_performance_overview_title"
      >
        <MLButton
          className={s.simpleAccordionTitleButton}
          onClick={handleToggle}
        >
          <MLIcon
            className={s.simpleModeIcon}
            type={isOpen ? 'chevron_down' : 'chevron_right'}
          />
          <span className={s.simpleAccordionTitle}>{title}</span>
        </MLButton>
        {!isOpen && !isMobile && renderPrimaryMetrics()}
      </div>
      {isOpen && renderPrimaryMetrics()}
      {isOpen && children}
    </div>
  );
};

export default SimpleAccordion;
